import ThemeService from '../services/theme.service';

export const theme = {
  namespaced: true,
  state: {
    themeList: [],
    themeListByProduct: []
  },
  actions: {
    async getThemeList({ commit }) {
      const resp = await ThemeService.getThemeList();
      if (resp.status === 200) {
        commit('SET_THEME_LIST', resp.data);
      }
      return resp.status;
    },
    async getThemeByProduct({ commit }, productId){
      const resp = await ThemeService.getThemeByProduct(productId)
      if( resp.status === 200){
        commit('SET_THEME_LIST_PRODUCT', resp.data);
      }
    },
    async createTheme(_, newTheme) {
      const resp = await ThemeService.createTheme(newTheme);
      return resp.status;
    },
    async editTheme(_, currentTheme) {
      const resp = await ThemeService.editTheme(currentTheme);
      return resp.status;
    },
    async deleteTheme(_, ThemeId) {
      const resp = await ThemeService.deleteTheme(ThemeId);
      return resp.status;
    },
  },
  mutations: {
    SET_THEME_LIST(state, themeList) {
      state.themeList = themeList;
    },
    SET_THEME_LIST_PRODUCT(state, list){
      state.themeListByProduct = list;
    }
  },
};
